module.exports = __webpack_public_path__ + "img/happy.80cf6a8e.png";